export const API_BASE_URL = "https://api.shrtco.de/v2/shorten?url=";
